import * as React from "react"
import { Link } from "gatsby"
import logo from "../images/97auto_logo_header.jpg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'

const Header = () => (
  <header>
    <div className="nav-top">
      <div className="text-right">
        <span>(443) 688-6721</span><span className="breaker">&nbsp;|&nbsp;</span>
        <span>info@97automotive.com</span>
      </div>
    </div>
    <div className="nav-main">
      <div className="logo-mobile">
        <Link to="/"><img src={logo} alt="Logo" /></Link>
      </div>
      <nav>
        <ul className="logo-wrapper">
            <li>
              <Link to="/"><img src={logo} alt="Logo" /></Link>
          </li>          
        </ul>
        <ul className="nav-wrapper">   
          <li>
              <Link to="/services">Services</Link>
          </li>  
          <li>
              <Link to="/about">About</Link>
          </li>
          <li>
              <Link to="/contact">Contact</Link>
          </li>
          <li>
            <a href="https://www.facebook.com/97Auto/" className="social m-2" rel="noreferrer noopener" target="_blank">
                <FontAwesomeIcon icon={faFacebook} /></a>   
                <a href="https://www.instagram.com/97_automotive/" className="social m-2" rel="noreferrer noopener" target="_blank">
                <FontAwesomeIcon icon={faInstagram} /></a>    
          </li>
        </ul>
      </nav>      
    </div>
  </header>
)

export default Header
